'use client';
import { useBalance, useReadContract } from 'wagmi';
import Stake from './Stake';
import UnstakeForm from './UnstakeForm';
import { getChainConstant } from '@/domain/chain';
import { Addresses } from '@/domain/addresses';
import { erc20Abi, formatEther } from 'viem';
import useAverageLockTime from '@/application/staking/useAverageLockTime';
import { useChain } from '@/hooks/useChain';

export interface StakeContainerProps {
  view?: 'stake' | 'unstake';
}

const StakeContainer = () => {
  const chain = useChain();

  const { data: averageLockTime } = useAverageLockTime();

  const { data: totalSupply } = useReadContract({
    address: getChainConstant(Addresses, chain?.id, 'FloorToken'),
    abi: erc20Abi,
    functionName: 'totalSupply',
  });

  const { data: daoFloor } = useBalance({
    token: getChainConstant(Addresses, chain?.id, 'FloorToken'),
    address: getChainConstant(Addresses, chain?.id, 'Treasury'),
  });

  const { data: multisigFloor } = useBalance({
    token: getChainConstant(Addresses, chain?.id, 'FloorToken'),
    address: getChainConstant(Addresses, chain?.id, 'Multisig'),
  });

  const { data: floorLocked } = useBalance({
    token: getChainConstant(Addresses, chain?.id, 'FloorToken'),
    address: getChainConstant(Addresses, chain?.id, 'VeFloorStaking'),
  });

  const supplyLocked =
    totalSupply &&
    floorLocked?.value &&
    daoFloor?.value != null &&
    multisigFloor?.value != null
      ? Number(formatEther(floorLocked.value)) /
        Number(formatEther(totalSupply - daoFloor.value - multisigFloor.value))
      : null;

  return (
    <Stake
      view="unstake"
      chain={chain}
      averageLockTime={averageLockTime}
      supplyLocked={supplyLocked}
      stakeForm={null}
      unstakeForm={<UnstakeForm />}
      chart={null}
    />
  );
};

export default StakeContainer;
